module.exports = __webpack_public_path__ + "img/img20.5c6fe0da.jpg";